<template>
<div class="main-selector-container" v-if="lang">
    <div class="header">
        <div class="logo">
            <img src="/static/img/logo.d5338d6.png">
        </div>
    </div>
    <div class="doctor-selector-container">
        <md-layout md-row md-sm-columns>
            <md-layout md-flex="100">
                <div style="width:100%"><h1>{{translate.pages.subordinates.doctor.h1}}</h1></div>
                <div style="width:100%"><h4>{{translate.pages.subordinates.doctor.h4}}</h4></div>
            </md-layout>
            <md-layout v-for="doctor in doctors" :key="doctor.id"  md-flex="33" md-flex-xsmall="100" md-flex-medium="50">
                <md-card >
                    <md-card-media-cover md-solid>
                        <md-card-media md-ratio="16:9">
                            <img v-if="doctor.image" :src="doctor.image" alt="">
                        </md-card-media>
                        <md-card-area>
                            <md-card-header>
                                <div class="md-title">{{ doctor.name }} {{ doctor.lastname }} {{ doctor.lastname2 }}</div>
                                <div class="md-subhead">{{ doctor.code }}</div>
                            </md-card-header>
                            <md-card-actions>
                                <md-button class="md-raised" @click.native="send(doctor.id)">{{translate.pages.subordinates.doctor.getin_btn}}</md-button>
                            </md-card-actions>
                        </md-card-area>
                  </md-card-media-cover>
                </md-card>
            </md-layout>
        </md-layout>
    </div>
</div>
</template>
<script>
export default {
    data() {
        return {
            prefix: this.$route.params.country,
            doctors: []
        }
    },
    created(){
        this.$store.dispatch('clearUser');
        // Get subordinate list
        this.$http.get('/doctor/subordinate/list', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
            }).then(response => {
                this.doctors = response.data.data.doctors;
                console.log(this.doctors)
            });
    },
    computed: {
        // Get Language
        translate(){
            return this.$store.getters.language.app[this.lang].prestador;
        },
        // Get lang
        lang(){
            return this.$store.getters.language.lang;
        }
    },
    methods: {
        // Store doctor
        send(doctor_id){
            this.$auth.setParent(doctor_id);
            this.$store.dispatch('setParent', doctor_id);
            this.$router.push({'name': 'Dashboard'});
        }
    }
}
</script>
<style lang="stylus" scoped>
    .main-selector-container *
        color #4d5667!important
    .md-title, .md-subhead
        color white!important
    .header
        background-color #fafafa
        box-shadow 0 1px 0 rgba(0,0,0,.05), 0 2px 5px rgba(0,0,0,.05)
        height 80px
        width 100vw
        text-align center
    .logo
        width 240px
        margin 0 auto
        height 80px
        line-height 80px
    .logo img
        max-width: 80%
    .doctor-selector-container
        margin 30px
    .md-card
        width 100%
        margin 0px
</style>





// WEBPACK FOOTER //
// Doctor.vue?1b24a926